import { render } from "./registeredTradesReports.vue?vue&type=template&id=6ec4e9e5&ts=true"
import script from "./registeredTradesReports.vue?vue&type=script&lang=ts"
export * from "./registeredTradesReports.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__